import { useState, useEffect } from 'react';

interface UseMediaQueryProps {
  query: string;
}

export default function useMediaQuery({ query }: UseMediaQueryProps): boolean {
  const [isMounted, setIsMounted] = useState(false);
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted) return;

    const checkMediaQuery = () => {
      if (window.matchMedia(query).matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    checkMediaQuery();

    const mediaQuery = window.matchMedia(query);
    mediaQuery.addEventListener('change', checkMediaQuery);

    return () => {
      mediaQuery.removeEventListener('change', checkMediaQuery);
    };
  }, [isMounted, query]);

  return matches;
}
